import { useMemo } from "react";
import { useFetch } from "../useFetch";
import type {
	CreateMethodPaymentPayload,
	MethodPaymentResponse,
	UpdateMethodPaymentPayload,
} from "../../core/types/control/method-payment";

export function useMethodPayments(page = 1, pageSize = 10) {
	const query = useMemo(() => ({ page, pageSize }), [page, pageSize]);

	return useFetch<MethodPaymentResponse[]>({
		endpoint: "/method-payments",
		method: "GET",
		query,
	});
}

export function useMethodPayment(id: number) {
	return useFetch<MethodPaymentResponse>({
		endpoint: `/method-payments/${id}`,
		method: "GET",
		auto: id > 0,
	});
}

export function useCreateMethodPayment() {
	const fetch = useFetch<MethodPaymentResponse, CreateMethodPaymentPayload>({
		endpoint: "/method-payments",
		method: "POST",
		auto: false,
	});

	const create = (
		data: CreateMethodPaymentPayload,
		files?: { payment_icon?: File },
	) => {
		return fetch.execute({ body: data, files });
	};

	return { ...fetch, create };
}

export function useUpdateMethodPayment(id: number) {
	const fetch = useFetch<MethodPaymentResponse, UpdateMethodPaymentPayload>({
		endpoint: `/method-payments/${id}`,
		method: "PATCH",
		auto: false,
	});

	const update = (
		data: UpdateMethodPaymentPayload,
		files?: { payment_icon?: File },
	) => {
		return fetch.execute({ body: data, files });
	};

	return { ...fetch, update };
}

export function usePatchMethodPayment() {
	const fetch = useFetch<MethodPaymentResponse, UpdateMethodPaymentPayload>({
		endpoint: "/method-payments",
		method: "PATCH",
		auto: false,
	});

	const patchById = (
		id: number,
		data: UpdateMethodPaymentPayload,
		files?: { payment_icon?: File },
	) => {
		return fetch.execute({
			endpoint: `/method-payments/${id}`,
			body: data,
			files,
		});
	};

	return { ...fetch, patchById };
}
